module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6b73c1dd54524c22aa4695fc442cadaa.png";